"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0016 2c-3.7754 0-6.836 3.0606-6.836 6.836v2.0175a.571.571 0 0 1-.1233.3543l-1.528 1.9301C1.9573 15.1046 3.358 18 5.8665 18h2.6333c0 1.933 1.567 3.5 3.5 3.5s3.5-1.567 3.5-3.5h2.637c2.5084 0 3.9091-2.8954 2.3522-4.8621l-1.528-1.9301a.5706.5706 0 0 1-.1233-.3543V8.8361C18.8377 5.0606 15.7771 2 12.0016 2zm-4.836 6.836C7.1656 6.1653 9.3307 4 12.0016 4c2.6709 0 4.8361 2.1652 4.8361 4.836v2.0175c0 .5793.1956 1.1415.5552 1.5957l1.528 1.9301c.519.6556.0521 1.6207-.7841 1.6207H5.8664c-.836 0-1.303-.9651-.784-1.6207l1.528-1.9301a2.5709 2.5709 0 0 0 .5552-1.5957V8.8361zM13.4998 18h-3c0 .8284.6716 1.5 1.5 1.5s1.5-.6716 1.5-1.5z"
  })];
};

exports.default = _default;